// eslint-disable-next-line
const manifest = require('./manifest.json');

/**
 * Build the URL for an icon.
 * @param {string} name
 *   The name of one of our SVG icons.
 * @param {string} theme
 *   The name of one of the themes in the themes package.
 * @param {string} publicPath
 *   The public path from which icons are served.
 */
module.exports = (name, theme, publicPath = '') => {
  const {
    hash,
    icons
  } = manifest;
  if (!(name in icons)) {
    throw new Error(`No icon with name "${name}" could be found in the icons manifest.`);
  }
  if (!theme) {
    throw new Error('A theme must be provided so we can establish any overrides');
  }
  const icon = icons[name];
  const hasOverride = icon.overrides.includes(theme);
  const iconBasePath = hasOverride ? `overrides/${theme}` : 'base';
  const publicBasePath = `${publicPath || ''}/${iconBasePath}`.replace(/\/\//g, '/');
  const {
    pathname: spriteMapPathName
  } = new URL(`${publicBasePath}/sprite-maps/${icon.groupName}-${hash}.svg`, 'http://temp') // we only care about the pathname here
  ;
  return spriteMapPathName.concat(`#${name}`);
};